import * as React from "react";
import CustomField from "../../../model/customField/CustomField";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {Dispatch} from "redux";
import {fetchLeadCustomFields} from "../../../store/action/customField/customField";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import {none, option, Option} from "ts-option";
import Toast from "../../helper/Toast";
import CustomFieldsDisplay from "../../admin/customFields/CustomFieldsDisplay";
import CustomFieldValue from "../../../model/job/CustomFieldValue";
import {OnSuccess} from "../../../store/action/actionHelpers";

interface ComponentProps {
	/**
	 * Lead custom fields values
	 */
	leadCustomFieldsValues: Option<CustomFieldValue[]>;
	/**
	 * Create lead custom field value
	 * @param {CustomFieldValue} createdCustomFieldValue
	 * @param {OnSuccess} onSuccess
	 */
	createLeadCustomFieldValue: (createdCustomFieldValue: CustomFieldValue, onSuccess: OnSuccess) => void;
	/**
	 * Update lead custom field value
	 * @param {CustomFieldValue} updatedCustomFieldValue
	 * @param {OnSuccess} onSuccess
	 */
	updateLeadCustomFieldValue: (updatedCustomFieldValue: CustomFieldValue, onSuccess: OnSuccess) => void;
	/**
	 * Remove lead custom field value
	 * @param {string} customFieldValueId
	 * @param {OnSuccess} onSuccess
	 */
	removeLeadCustomFieldValue: (customFieldValueId: string, onSuccess: OnSuccess) => void;
}

interface IDispatchProps {
	/**
	 * Fetch lead custom fields method
	 */
	fetchLeadCustomFields: () => void;
}

interface ReduxProps {
	/**
	 * Lead custom fields list.
	 */
	leadCustomFields: Option<CustomField[]>;
}

type Props = IDispatchProps & ReduxProps & ComponentProps;

class LeadCustomFields extends React.Component<Props> {

	constructor(props: Props) {
		super(props);
		this.updateCustomFieldValue = this.updateCustomFieldValue.bind(this);
		this.removeCustomFieldValue = this.removeCustomFieldValue.bind(this);
		this.createCustomFieldValue = this.createCustomFieldValue.bind(this);
	}

	render() {
		return (
			<CustomFieldsDisplay customFields={this.props.leadCustomFields}
								 customFieldsValues={this.props.leadCustomFieldsValues}
								 fetchCustomFields={this.props.fetchLeadCustomFields}
								 createCustomFieldValue={this.createCustomFieldValue}
								 updateCustomFieldValue={this.updateCustomFieldValue}
								 removeCustomFieldValue={this.removeCustomFieldValue}/>
		)
	}

	createCustomFieldValue(createdCustomFieldValue:CustomFieldValue) {
		this.props.createLeadCustomFieldValue(createdCustomFieldValue, this.onCreateSuccess);
	}

	onCreateSuccess() {
		return Toast.success('Lead custom field value created', 'Lead custom field create');
	}

	updateCustomFieldValue(updatedCustomFieldValue: CustomFieldValue) {
		this.props.updateLeadCustomFieldValue(updatedCustomFieldValue, this.onUpdateSuccess)
	}

	onUpdateSuccess() {
		return Toast.success('Lead custom field value updated', 'Lead custom field update');
	}

	removeCustomFieldValue(customFieldValueId: string) {
		this.props.removeLeadCustomFieldValue(customFieldValueId, this.onRemoveSuccess)
	}

	onRemoveSuccess() {
		return Toast.success('Lead custom field value removed', 'Lead custom field removed');
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchLeadCustomFields: () => dispatch(
			fetchLeadCustomFields(() => {}, (error) => notifyBugsnagAndShowToast(error, "Fetch lead custom fields"))
		)
	};
}

function mapStateToProps(state: RootState) {
	const filtered = state.customFields.leadCustomFields.getOrElse([]).filter(item => !item.disabledInUi);
	return {
		leadCustomFields: state.customFields.leadCustomFields.isDefined ? option(filtered) : none
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(LeadCustomFields)